export default __webpack_public_path__ + "static/media/curved-arrow.2f1e3783.svg";